const selectors = {
  rating: '.loox-rating-label',
  looxRatingParent: '.loox-rating',
};

function transformRating(parent) {
  if (!parent.querySelector(selectors.rating)) return;
  const text = parent.querySelector(selectors.rating).innerHTML;
  const ratingContainer = parent.querySelector(selectors.rating);

  if (ratingContainer && !ratingContainer.innerHTML.includes('Reviews'))
    ratingContainer.innerHTML = `${text.trim().split("(")[1].slice(0, -1).split(",").join("")} Reviews`;
}

function looxMutationObserver(parent) {
  if (!parent.querySelector(selectors.looxRatingParent)) return;

  const targetNode = parent.querySelector(selectors.looxRatingParent);
  const config = {
    childList: true,
    subtree: true,
  };

  const callback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === "childList") {
        targetNode.innerHTML.trim() == "" && transformRating(parent);
        observer.disconnect();
      }
    }
  };

  const observer = new MutationObserver(callback);

  observer.observe(targetNode, config);
}
